import React from "react";
import { FaTimes } from "react-icons/fa";
import { RiCloseLine } from "react-icons/ri";

function Modal({
  opened,
  onClose,
  className,
  title,
  actions,
  preventClose,
  transparent,
  children,
}) {
  return opened ? (
    <div className='fixed left-0 top-0 right-0 bottom-0 z-50 overflow-y-auto overflow-x-hidden bg-black/50'>
      <div
        className='w-full h-full absolute top-0 left-0 bottom-0 right-0'
        onClick={preventClose ? null : onClose}
      />
      <div
        className={`z-50 absolute top-20 left-1/2 -translate-x-1/2  mx-auto rounded-lg ${
          transparent ? "" : "shadow-2xl bg-white"
        } ${className && className !== "" ? className : "max-w-xl"}`}
      >
        {title !== undefined && (
          <div className='flex items-center justify-between px-4 py-2 border-b border-gray-300'>
            <h3 className='m-0 text-base mr-2 font-semibold text-black'>
              {title}
            </h3>
            <button
              type='button'
              className='text-black text-xl'
              onClick={onClose}
            >
              <RiCloseLine />
            </button>
          </div>
        )}
        {children !== undefined && (
          <div className={location.pathname !== "/" ? "p-4" : ""}>
            {children}
          </div>
        )}
        {actions !== undefined && (
          <div className='p-2 flex justify-end'>{actions}</div>
        )}
      </div>
    </div>
  ) : null;
}

export default Modal;
